import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M10.5005 10.9763L14.6254 6.85156L15.8039 8.03007L10.5005 13.3334L5.19727 8.03007L6.37577 6.85156L10.5005 10.9763Z",
			fill: "currentColor"
		})
	})
});
export default SvgChevronDown;
